import { useState } from 'react';
import { useAuth } from '../auth/useAuth';
import { cancelAccountDeletion } from '../api/account';
import { apiErrorMessage } from '../api/errorMessage';
import { formatDeletionDate } from './deletionDate';

/// Shown across the top of the dashboard when the signed-in user has a
/// pending account deletion. Renders nothing when the account is live
/// — callers can drop this in unconditionally.
export default function DeletionBanner() {
  const { user, refreshUser } = useAuth();
  const [cancelling, setCancelling] = useState(false);
  const [error, setError] = useState('');

  if (!user?.deleted_at || !user?.scheduled_purge_at) {
    return null;
  }

  const purgeDate = formatDeletionDate(user.scheduled_purge_at);

  async function handleCancel() {
    setError('');
    setCancelling(true);
    try {
      await cancelAccountDeletion();
      await refreshUser();
    } catch (err) {
      setError(apiErrorMessage(err, 'Failed to cancel deletion. Please try again.'));
    } finally {
      setCancelling(false);
    }
  }

  return (
    <div
      className="deletion-banner"
      role="alert"
      aria-label="Account scheduled for deletion"
    >
      <div className="deletion-banner-text">
        <strong>Your account is scheduled for deletion</strong>
        <span>
          We&apos;ll permanently remove your account on{' '}
          <strong>{purgeDate}</strong>. Cancel here if this wasn&apos;t you.
        </span>
        {error && <span className="deletion-banner-error">{error}</span>}
      </div>
      <button
        className="btn btn-secondary btn-sm"
        onClick={handleCancel}
        disabled={cancelling}
      >
        {cancelling ? 'Cancelling…' : 'Cancel deletion'}
      </button>
    </div>
  );
}

